<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Fx Rate SetUp</div>
        <div>
          <bread-crumb :bread-crumbs="['FX Rate Setup']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-tabs v-model="usertype">
        <v-tab
          v-for="item in items"
          :key="item.key"
          :href="'#' + item.key"
          class="text-capitalize text-decoration-none"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="usertype">
        <!-- <v-tab-item id="all">
          <allSetupVue />
        </v-tab-item> -->
        <v-tab-item id="country">
          <serviceCountrywise />
        </v-tab-item>
        <v-tab-item id="payout"> <servicePayoutwise /> </v-tab-item>
        <v-tab-item id="branch"> <CountryBranchWise /> </v-tab-item>
        <v-tab-item id="partner"> <partnerBranchWise /> </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
// import allSetupVue from "./serviceChargetabs/allSetup.vue";
import serviceCountrywise from "./fxRatesSetuptabs/serviceCountrywise.vue";
import servicePayoutwise from "./fxRatesSetuptabs/servicePayoutwise.vue";
import CountryBranchWise from "./fxRatesSetuptabs/CountryBranchWise.vue";
import partnerBranchWise from "./fxRatesSetuptabs/partnerBranchWise.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "FX Rate Setup",
  data: () => {
    return {
      usertype: "Induvisual",
      items: [
        // { label: "All setup", key: "all" },
        { label: "Country Wise", key: "country" },
        { label: "Country Branch Wise", key: "branch" },
        { label: "Partner Wise", key: "payout" },
        { label: "partner wise by sender branch", key: "partner" },
      ],
    };
  },
  components: {
    BreadCrumb,
    // allSetupVue,
    servicePayoutwise,
    serviceCountrywise,
    CountryBranchWise,
    partnerBranchWise,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
